import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Constellation App. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
